import React from "react";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import ThemeProvider from "./ThemeProvider";
import AuthProvider from "./AuthProvider";
import { queryClient } from "../lib/queryClient";
// Side-effect: dayjs plugin'leri + tr locale (calendar feature için)
import "../features/calendar/hooks/useDayjsSetup";

/**
 * Tek bootstrap noktası. Hiyerarşi (Faz 1 + 5 + 6):
 *   QueryClientProvider  — React Query cache (Faz 5)
 *     AuthProvider       — IAuthAdapter köprüsü (Faz 6)
 *       ThemeProvider    — eski Customizer + AnimationTheme (Faz 1)
 *         <ToastContainer> — tek konsolide mount (Faz 1)
 *
 * Faz 7'de ErrorBoundary kökte eklenecek.
 */
const AppProviders = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ThemeProvider>
        {children}
        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      </ThemeProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default AppProviders;
